import React from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";
import styles from "./styles";
import {
  DialogTitle,
  IconButton,
  Dialog,
  DialogContent,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
export const ModalVideo = ({ open, handleClose, title, url }) => {
  const classes = styles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="player-video"
      aria-describedby="player-video-description"
      maxWidth={"md"}
    >
      <DialogTitle id="player-video">
        <Typography component="p" className={classes.titleModal}>
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={classes.dialogContentContainer}>
        <ReactPlayer
          className={classes.reactPlayerStyle}
          url={url}
          playing
          config={{
            vimeo: {
              playerOptions: {
                controls: true
              }
            },
            youtube: {
              playerVars: {
                showinfo: 1,
                origin: "http://localhost:3000/"
              }
            }
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

ModalVideo.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  url: PropTypes.string,
  title: PropTypes.string
};
